export const environment = {
  production: true,
  algolia: {
    apikey: '605fa338e56eb9171fec13f716908b6f',
    applicationId: '5G37W5YM1S',
  },
  disableFlexPosEvents: false,
  flexPosApiKey: '',
  magento: {
    graphql: 'https://magento.supervin.dk/efiware/page/graphql',
    flexposApiKey: '1b1435e2-fb9b-4a4b-8e3b-104737c2fd18',
  },
  cvrapi: {
    url: 'https://cvrapi.dk/api',
  },
  sentry: {
    environment: 'Production',
    DSN: 'https://4eda51f33b4c78f1a45cccb03ee79bef@o4504288101728256.ingest.us.sentry.io/4508647898480640'
  }
};
